import { put, select, takeLatest } from "redux-saga/effects";

import { getProductsFail, getProductsSuccess, getSectionPricesRequest } from "../actions";
import { GET_PRODUCTS_REQUEST, GetProductsRequestAction, CMSProductType } from "../types";
import cmsApi from "../../utils/api-helper/cmsApi";
import { CMS_ENVIRONMENT, DEFAULT_REGION, getSectionPriceRegion, normalizeProductRegions, RegionCode } from "../../utils/constants";

function* getProductsSaga(action: GetProductsRequestAction) {
    try {
        //@ts-ignore
        const selectedRegion: string = yield select((state) => state.region?.code ?? DEFAULT_REGION);
        const availabilityRegion = selectedRegion as RegionCode;
        //@ts-ignore
        const res = yield cmsApi.get("/products?populate[category][fields][0]=slug&populate[FirstBox][populate][Image][fields][0]=url&populate[Images][fields][0]=url&pagination[limit]=-1");
        const products = (res.data.data as CMSProductType[]).map((product) => {
            const regions = normalizeProductRegions(product.attributes.Regions ?? []);
            const pid = CMS_ENVIRONMENT === "prod" ? product.attributes.productId : product.attributes.productTestId;
            const isAvailable = !!pid && (regions.length === 0 || regions.includes(availabilityRegion));
            return {
                id: product.id,
                productId: pid,
                name: product.attributes.Name,
                category: product.attributes.category.data.attributes.slug,
                image: product.attributes.FirstBox?.[0]?.__component === "boxes.image" ? product.attributes.FirstBox[0].Image?.data?.attributes?.url ?? "" : "",
                price: product.attributes.Price,
                isActive: product.attributes.Active,
                stripeProductId: CMS_ENVIRONMENT === "prod" ? product.attributes.StripeProductId : product.attributes.StripeProductTestId,
                priceType: product.attributes.PriceType?.toLowerCase(),
                period: product.attributes.Period,
                sortNumber: product.attributes.SortNumber,
                showNameLine: product.attributes.ShowNameLine,
                locked: product.attributes.Locked,
                firstBox: product.attributes.FirstBox,
                secondBox: product.attributes.SecondBox,
                thirdBox: product.attributes.ThirdBox,
                emphasized: product.attributes.Emphasized,
                selected: product.attributes.Selected,
                regions,
                isAvailable,
                images: (product.attributes.Images?.data ?? []).map((img: any) => img.attributes.url),
            };
        });
        yield put(getProductsSuccess(products));

        // Fetch region-specific prices for available products. Dispatch even
        // when empty so region loading cannot stay true on locales with no data.
        const productIds = Array.from(new Set(products.filter((p) => p.isAvailable).map((p) => p.productId).filter(Boolean))) as string[];
        const sectionPriceRegion = getSectionPriceRegion(selectedRegion);
        yield put(getSectionPricesRequest(sectionPriceRegion, productIds));
    } catch (error) {
        yield put(getProductsFail(error));
    }
}

// for admin

function* saveState() {
    //@ts-ignore
    const state = yield select();
    yield localStorage.setItem("initState", JSON.stringify(state));
}

const sagaWatcher = [takeLatest(GET_PRODUCTS_REQUEST, getProductsSaga), takeLatest("*", saveState)];

export default sagaWatcher;
